export default __webpack_public_path__ + "static/media/profile-bg2.6cc889c8.jpg";